// styles
import styles from '../styles/Button.module.css';
import { icons } from '../utils/icons';
import Loader from './Loader';

// Delete this when every button is replaced with AppButton
interface ButtonProps {
  text: string | JSX.Element;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  id?: string;
  href?: string;
  isLoading?: boolean;
  variant?: string;
  sx?: {
    [key: string]: string | number;
  };
  iconName?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  disabled,
  id,
  href,
  isLoading,
  variant,
  sx,
  iconName,
}) => {

  return (
    <button
      className={`${styles.button} ${variant ? `${styles[variant]}` : ''} ${iconName ? styles.iconButton : ''} delayed-fadein`}
      onClick={(e) => {
        onClick && onClick(e);
        if (href) {
          window.location.href = href;
        }
      }}
      disabled={disabled}
      id={id}
      style={{ ...sx }}
    >
      {iconName &&
        <span className={styles.icon}>
          {icons[iconName]}
        </span>
      }
      <p>{isLoading ? <Loader /> : text}</p>
    </button>
  )
};

export default Button;
